export const SEARCH_PARAM_KEYS = {
  ASK_WHY_SURVEY_ID: 'ask_why_survey_id',
  COMPARE_BY: 'compare_by',
  QUESTION_OPTION: 'option_ids',
  QUOTA_GROUP: 'group_ids',
};
